import { useQuery } from '@tanstack/react-query';
import { Select, type SelectProps } from 'antd';
import { getSalaryScalesDropdown } from 'src/apis/master_data/salaryScale.api';

export default function SalaryScaleSelect({ value, onChange, style, allowClear, ...props }: SelectProps) {
  const salaryScalesDropdownQuery = useQuery({
    queryKey: ['salaryScalesDropdown'],
    queryFn: () => getSalaryScalesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      allowClear={allowClear}
      value={salaryScalesDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      options={salaryScalesDropdownQuery.data?.data.map((item) => ({
        value: item.id,
        label: item.name,
        salaryScale: item
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={salaryScalesDropdownQuery.isFetching}
      {...props}
    />
  );
}
